
import Table from "./table.vue";

export default {
  components: { Table },
  data() {
    return {
      requestType: "Form",
      json: {
        rootType: "Object",
      },
      raw: {
        contentType: "application/json",
      },
    };
  },
};
